import axios from 'axios';
import { API_BASE_URL, API_TARGET_URL, USING_DEV_PROXY } from './data-source/base-url';
import { logger } from './logger';

const resolvedBase =
  import.meta.env.VITE_BACKEND_URL ??
  API_BASE_URL ??
  API_TARGET_URL ??
  '';

const trimmedBase = resolvedBase === '/' ? '/' : resolvedBase.replace(/\/+$/, '');
const baseURL = trimmedBase || (USING_DEV_PROXY ? '/' : '');

if (!baseURL && !USING_DEV_PROXY) {
  logger.error('[httpClient] Missing backend base URL configuration. Requests will fail.');
}

export const httpClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});
